import { useQuery } from '@tanstack/react-query';

import API from '../../../api';
import { QUERY_KEYS } from '../../../shared/queryKeys';
import { ITranscodingJobDetails } from '../../../types/fileTypes';

/**
 * Custom hook to fetch video transcoding job details
 *
 * @param transcodingJobId - The transcoding job ID
 * @param enabled - Whether to enable the query (default: true)
 * @returns useQuery result with transcoding job details data
 */
export const useVideoTranscodingJobDetails = (
  transcodingJobId: string,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: QUERY_KEYS.VIDEO_TRANSCODING_JOB_DETAILS(transcodingJobId),
    queryFn: () => API.getVideoTranscodingJobDetails(transcodingJobId),
    enabled: Boolean(transcodingJobId) && enabled,
    select: (resp) => resp.data.result as ITranscodingJobDetails,
  });
};
